import _ from 'lodash';
import React from 'react';

import Loading from 'components/Loading';
import Table from 'components/Table';
import DocumentWithFilename from 'components/DocumentWithFilename';

import Dropzone from 'components/Dropzone';
import {UploadFilePlaceholder, WrongFormat} from 'components/SingleFileUpload';

import {formatDate} from 'utils/datetime';
import {headOption} from 'utils/common';
import {openUrlInNewTab} from 'utils/files';
import {ACCEPTED_DOCUMENT_FILE_TYPES} from 'ducks/files';

import './styles.css';

interface DocumentProp {
  id: number;
  filename: string;
  createdAt: string;
  addedBy: string;
  documentUrl: string;
}

interface RoomCheckDetailDocumentSectionProps {
  document: DocumentProp;
  uploadingDocument: boolean;
  removeDocument: ({documentId: number}) => any;
  dropDocument: ({document: any}) => any;
  documentIcon: any;
  placeholderText: string;
  fileLabel: string;
}

const DocumentRow = ({document, removeDocument, downloadDocument}) => (
  <Table.Row>
    <Table.Cell
      className="filename"
      onClick={() =>
        downloadDocument({
          previewUrl: document.documentUrl
        })
      }>
      <DocumentWithFilename filename={document.filename} />
    </Table.Cell>
    <Table.Cell className="filetype" />
    <Table.Cell className="createdAt">
      {formatDate(document.createdAt)}
    </Table.Cell>
    <Table.Cell className="addedBy">{document.addedBy}</Table.Cell>
    <Table.Cell
      className="remove colab-bold"
      onClick={() => removeDocument({documentId: document.id})}>
      Remove
    </Table.Cell>
  </Table.Row>
);

// This component will be used for Arrival  & DepartureRoomChecks
class RoomCheckDetailDocumentSection extends React.Component<
  RoomCheckDetailDocumentSectionProps
> {
  state = {
    wrongFormat: false
  };

  onDocumentDrop = files => {
    if (_.isEmpty(files)) {
      return this.setState({wrongFormat: true});
    }

    this.setState({
      wrongFormat: false
    });
    const document = headOption(files);

    this.props.dropDocument({document});
  };

  downloadDocument = ({previewUrl}) => {
    openUrlInNewTab(previewUrl);
  };

  render() {
    const {
      document,
      uploadingDocument,
      documentIcon,
      placeholderText,
      fileLabel
    } = this.props;
    const {wrongFormat} = this.state;

    return (
      <div className="RoomCheckDetailDocumentSection">
        <div className="RoomCheckDetailDocumentSection__header colab-bold">
          {fileLabel}
        </div>

        {uploadingDocument && <Loading />}

        {!uploadingDocument &&
          !_.isNil(document) && (
            <div className="RoomCheckDetailDocumentSection__table">
              <Table>
                <Table.Header>
                  <Table.HeaderItem heading="Filename" className="filename" />
                  <Table.HeaderItem heading="Type" className="filetype" />
                  <Table.HeaderItem heading="Uploaded" className="createdAt" />
                  <Table.HeaderItem heading="Uploaded by" className="addedBy" />
                  <Table.HeaderItem className="remove" />
                </Table.Header>
              </Table>
              <Table>
                <Table.Body>
                  <DocumentRow
                    key={document.id}
                    document={document}
                    removeDocument={this.props.removeDocument}
                    downloadDocument={this.downloadDocument}
                  />
                </Table.Body>
              </Table>
            </div>
          )}
        {/*TODO: The className FileUpload will be deleted when UploadFilePlaceholder is created a common component*/}
        {!uploadingDocument &&
          _.isNil(document) && (
            <div className="RoomCheckDetailDocumentSection__upload FileUpload">
              <Dropzone
                onDrop={this.onDocumentDrop}
                multiple={false}
                acceptedFileTypes={ACCEPTED_DOCUMENT_FILE_TYPES}
                defaultComponent={
                  <React.Fragment>
                    {wrongFormat && <WrongFormat />}
                    {!wrongFormat && (
                      <UploadFilePlaceholder
                        placeholderIcon={documentIcon}
                        placeholderText={placeholderText}
                      />
                    )}
                  </React.Fragment>
                }
              />
            </div>
          )}
      </div>
    );
  }
}

export default RoomCheckDetailDocumentSection;
